<template>
    <div :class="imgoption.size+' '" @click.stop="uploadimages">
        <el-image 
            :src="thumb ? thumb : require('@/assets/icon/default-img.png')" 
            fit="cover" 
            :class="thumb ? '' : 'defaultthumb' " 
        />
        <span v-if="imgoption.title && imgoption.title!=''">（{{imgoption.title}}）</span>
    </div>
    <systemphotos 
        v-model:isshow="isshow" 
        :issingle="false" 
        :returnSize="imgoption.returnsize"
        :phototype="option && option.phototype ? option.phototype : 'shop'"
        @finish="handleFinish"
    />
</template>

<script>
import systemphotos from '@/components/systemphotos/index';
export default {
  props: ['value','option'],
  components: {
        systemphotos,
  },
  data() {
      return {
          isshow:false,
          thumb: this.value && this.value!='' ? this.value : '',
          imgoption: {
              title: this.option && this.option.title ? this.option.title : '',
              size: this.option && this.option.size ? this.option.size : 'large',
              returnsize: this.option && this.option.returnsize ? this.option.returnsize : 'middle',
          },
      }
  },

  watch: {
      value(val) {
          this.thumb=val;
      },
  },

  mounted() {
      
  },

  methods: {

      uploadimages() {
          this.isshow = true;
      },

      handleFinish(val) {
          this.isshow = false;
          if(val.type=='submit' && val.data && val.data.length>0) this.$emit('finish',{url:val.data[0]});
      },

  }

}
</script>

<style scoped>
.large {cursor: pointer;width:auto !important;width:100px !important;height:100px;position:relative;}
.large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.middle {cursor: pointer;width:auto !important;width:70px !important;height:70px;position:relative;}
.middle .el-image {width:70px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.middle span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.small {cursor: pointer;width:auto !important;width:50px !important;height:50px;position:relative;}
.small .el-image {width:50px;height:50px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.small span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.banner {cursor: pointer;width:auto !important;width:150px !important;height:70px;position:relative;}
.banner .el-image {width:150px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.banner span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;} 

::v-deep(.defaultthumb) {display: inline-flex !important;justify-content: center !important;align-items: center !important;}
::v-deep(.defaultthumb .el-image__inner) {width:70px;height: 70px;}
</style>